<template>
	<div>
		<video class="bg-video" src="/footage/agac.mp4" autoplay muted loop></video>
		<CircleLink :link-route-name="'paratoner'" :link-pos="[605,155]"></CircleLink>
		<CircleLink :link-route-name="'dal'" :link-pos="[645,510]"></CircleLink>
		<CircleLink :link-route-name="'yaprak'" :link-pos="[695,340]"></CircleLink>
		<CircleLink :link-route-name="'metin'" :link-pos="[538,614]"></CircleLink>
		<CircleLink :link-route-name="'metin2'" :link-pos="[640,610]"></CircleLink>

		<router-link :to="{name:'kunye'}" class="page-nav-link" id="link-right"><img class="link-image" src="images/arrow-down-white-02.png" alt="" style="max-height: 60px;"></router-link>


	</div>
</template>

<script>
	import CircleLink from "../components/CircleLink"
	import _ from 'lodash'

	export default {
		name: "Agac",
		components: {CircleLink,},
		computed: {
			pageLinks: function () {
				var thisPagesLinks = _.find(this.$store.state.linksCollection, {'pageName': 'agac'})
				return thisPagesLinks.pageLinks
			}
		}
	}
</script>

<style scoped>
	.bg-video {
		top: 0;
		left: 0;
		position: absolute;
		object-fit: cover;
		width: 100%;
		height: 100%;
		z-index: -2;
	}
</style>